import { formatDateTime } from "$root/localization/formatters";
import { AutoTooltip, Icon, TooltipContent, Column, Text } from "@mdotm/shadcn/legacy/components";
import { themeCSSVars } from "@mdotm/shadcn/legacy/themes";
import { switchExpr } from "@mdotm/shadcn/legacy/utils";

const autoSyncStatusPositionByVariant = {
	compat: "left",
	verbose: "bottom",
} as const;

export function AutoSyncStatus(props: {
	syncDate?: string;
	lastMetricImportDate?: string;
	variant: "compat" | "verbose";
}): React.JSX.Element {
	return (
		<AutoTooltip
			maxWidth={400}
			position={autoSyncStatusPositionByVariant[props.variant]}
			overrideColor={themeCSSVars.palette_N200}
			trigger={({ innerRef }) =>
				switchExpr(props.variant, {
					compat: () => <Icon icon="synch-Cloud" innerRef={innerRef} color={themeCSSVars.palette_N400} size={20} />,
					verbose: () => (
						<div className="flex space-x-2 items-center" ref={innerRef}>
							<Icon icon="synch-Cloud" color={themeCSSVars.palette_N400} size={20} />
							<span className="mr-2">Sync</span>
							<strong>Active</strong>
						</div>
					),
				})
			}
		>
			<TooltipContent>
				<Column gap={4}>
					<Text type="Body/M/Bold">Sync</Text>
					<Text type="Body/M/Book" className="whitespace-pre-line ">
						{props.syncDate && <>Last portfolio update - {formatDateTime(props.syncDate)}</>}
						{props.lastMetricImportDate && (
							<>
								{props.syncDate ? "\n" : ""}
								Last performance update - {formatDateTime(props.lastMetricImportDate)}
							</>
						)}
					</Text>
				</Column>
			</TooltipContent>
		</AutoTooltip>
	);
}
